"use client";
import { Image, Text, Flex, Show } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import Link from "next/link";
import instagram from "@public/instagram.png";

const Im = ({
  source,
  alt, // Add alt prop here
  onClick,
  text,
  isLoading,
  selected,
  show,
  showInstagram,
}: {
  source: string;
  alt: string; // Define alt prop here
  text: string;
  isLoading: boolean;
  selected: boolean;
  show: boolean;
  onClick: () => void;
  showInstagram: boolean;
}) => {
  const [blurValue, setBlurValue] = useState(isLoading ? 20 : 0);

  useEffect(() => {
    let interval: number | undefined;
    if (isLoading) {
      setBlurValue(20);
      interval = window.setInterval(() => {
        setBlurValue((prevBlur) => (prevBlur > 0 ? prevBlur - 6.4 : 0));
      }, 1700);
    }
    return () => {
      if (interval !== undefined) {
        clearInterval(interval);
      }
    };
  }, [isLoading, source]);

  const nameToIGLink: { [key: string]: string } = {
    Aitana: "https://www.instagram.com/fit_aitana/",
    Hitomi: "https://www.instagram.com/lilhitomi_/",
    "Hoppy Floppy": "https://www.instagram.com/hoppy_floppy_2/",
    "Lucy Dream": "https://www.instagram.com/lucydream.ai/  ",
  };

  const gradientBorder = {
    position: "relative",
    bg: "transparent",
    border: "1px solid transparent",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: "16px",
      background: "linear-gradient(to right, #FFB5FF, #1AA5D3)",
      zIndex: 0,
    },
  };

  if (!text) {
    return (
      <Flex
        w="100%"
        h="100%"
        borderRadius="lg"
        borderWidth="1px"
        justify="center"
        align="center"
        borderColor={selected ? "#712EFF" : "transparent"}
        display={show ? "flex" : "none"}
        onClick={() => onClick()}
        cursor={isLoading && blurValue === 0 ? "pointer" : "default"}
      >
        <Image
          src={source}
          alt={alt} 
          loading="lazy"
          objectFit="fill"
          filter={`blur(${blurValue}px)`}
          borderRadius="10px"
        />
      </Flex>
    );
  }

  return (
    <Flex
      p={0.5}
      sx={selected ? gradientBorder : { border: "1px solid #040506", borderRadius: "16px" }}
    >
      <Flex
        direction="column"
        borderRadius="16px"
        p={{ base: "12px", md: "28px" }}
        minW={{ base: "130px", md: "" }}
        minH={{ base: "160px", md: "" }}
        w="100%"
        bg="black"
        zIndex={1}
        onClick={() => onClick()}
      >
        <Image
          minH={{ base: "115px", md: "150px" }}
          minW={{ base: "115px", md: "150px" }}
          src={source}
          alt={alt}  
          loading="lazy"
          filter={`blur(${blurValue}px)`}
          cursor={isLoading && blurValue === 0 ? "pointer" : "default"}
          borderRadius="10px"
          mt={{ base: "20px", md: "0px" }}
          zIndex={1} // Ensure the image is below the overlay
        />
        <Flex mt="16px" justify={{ base: "center", md: "space-between" }} align="center">
          <Text fontSize={{ base: "12px", md: "16px" }}>{text}</Text>
          {/* Desktop, >= 768px */}
          <Show above="md">
            <Link
              style={{ display: showInstagram ? "inline" : "none" }}
              target="_blank"
              href={nameToIGLink[text] ?? ":"}
            >
              <Image src={instagram.src} alt="Instagram link" /> {/* Optional alt text for Instagram icon */}
            </Link>
          </Show>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Im;
